import { useCallback, useContext, useEffect, useState } from "react"
import SidebarContext from "../contexts/SidebarContext/context"

export const useBounds = (ref) => {
  const { sidebar } = useContext(SidebarContext)

  const [bounds, setBounds] = useState<DOMRect | null>(ref?.current?.getBoundingClientRect())

  const getBoundsFromRef = useCallback(() => {
    if (ref?.current) setBounds(ref?.current?.getBoundingClientRect())
  }, [ref])

  useEffect(() => {
    window.addEventListener('scroll', getBoundsFromRef, true)
    window.addEventListener('resize', getBoundsFromRef)

    if (ref?.current && !bounds) setBounds(ref?.current?.getBoundingClientRect())

    return () => {
      window.removeEventListener('scroll', getBoundsFromRef, true)
      window.removeEventListener('resize', getBoundsFromRef)
    }
  }, [ref])

  useEffect(() => {
    getBoundsFromRef()
  }, [sidebar.isOpen])

  return {
    bounds
  }
}